[
  {
    "code": "NL-DR",
    "name": "Drenthe"
  },
  {
    "code": "NL-FL",
    "name": "Flevoland"
  },
  {
    "code": "NL-FR",
    "name": "Fryslân"
  },
  {
    "code": "NL-GE",
    "name": "Gelderland"
  },
  {
    "code": "NL-GR",
    "name": "Groningen"
  },
  {
    "code": "NL-LI",
    "name": "Limburg"
  },
  {
    "code": "NL-NB",
    "name": "Noord-Brabant"
  },
  {
    "code": "NL-NH",
    "name": "Noord-Holland"
  },
  {
    "code": "NL-OV",
    "name": "Overijssel"
  },
  {
    "code": "NL-UT",
    "name": "Utrecht"
  },
  {
    "code": "NL-ZE",
    "name": "Zeeland"
  },
  {
    "code": "NL-ZH",
    "name": "Zuid-Holland"
  }
]